export default "__VITE_ASSET__Pa8zZT3O__"